var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('sidebar-filter',{attrs:{"elements":_vm.pages,"selected":_vm.selectedPage},on:{"changed":_vm.sidebarChanged}}),_c('modal-price-list-date-edit',{attrs:{"open":_vm.openPriceListDateModal},on:{"close":_vm.priceListDateEditEnd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }